export enum SplitTestComponentTypeEnum {
  original = 'original',
  variant = 'variant',
}

export const SplitTestComponentTypeTitles = {
  [SplitTestComponentTypeEnum.original]: 'dashboard.funnel.split_tests.original_title',
  [SplitTestComponentTypeEnum.variant]: 'dashboard.funnel.split_tests.variant_funnel_step',
}
